import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map, tap } from 'rxjs/operators';

import * as fromRouterActions from '../actions/router.actions';

@Injectable()
export class RouterEffects {
  constructor(
    private actions$: Actions,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private location: Location
  ) {}

  navigate$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromRouterActions.RouterActionTypes.Go),
        map((action: fromRouterActions.Go) => action.payload),
        tap(({ commands, extras }) => this.router.navigate(commands, extras))
      ),
    { dispatch: false }
  );

  navigateBack$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromRouterActions.RouterActionTypes.Back),
        tap(() => this.location.back())
      ),
    { dispatch: false }
  );

  navigateForward$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromRouterActions.RouterActionTypes.Forward),
        tap(() => this.location.forward())
      ),
    { dispatch: false }
  );

  updateUrl$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromRouterActions.RouterActionTypes.UpdateLocation),
        map(({ payload: { extras } }: { payload: fromRouterActions.RouterPayload }) =>
          /* Updates the url without navigating to the updated page
           * by replacing the latest on the history stack
           */
          this.router.navigate([], {
            relativeTo: this.activatedRoute,
            queryParams: extras ? extras.queryParams : {},
            queryParamsHandling: 'merge',
            replaceUrl: true,
          })
        )
      ),
    { dispatch: false }
  );
}
